import React, { useEffect, useState } from 'react';
import { required } from 'redux-freeform';
import {
  ButtonWithAction,
  Cluster,
  FormContainer,
  FormInput,
  util,
  Box,
} from '@thecb/components';

import { formatCurrencyInput } from '../../../utils/helpers';

import {
  cashReducer,
  cashMapStateToProps,
  cashMapDispatchToProps,
} from '../CheckoutForm.state';
import { useSelector } from 'react-redux';
import { CASH } from '../../../utils/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { requireErrors, paymentAmountErrors } from './shared-constants';

let CashCheckoutForm = ({
  actions,
  fields,
  makePayment,
  remainingBalance,
  processBtnText,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [changeDue, setChangeDue] = useState();
  const [errors, handleErrors] = useState(false);
  const { isLoading } = useSelector((state) => state.checkout);
  const { payerNameRequired } = useSelector(
    (state) => state.shared.clientConfig,
  );

  useEffect(() => {
    if (payerNameRequired) {
      actions.fields.first_name.addValidator(required());
      actions.fields.last_name.addValidator(required());
    }
  }, [actions.fields.first_name, actions.fields.last_name, payerNameRequired]);

  useEffect(() => {
    if (remainingBalance) {
      actions.fields.amount.set(formatCurrencyInput(remainingBalance));
    }
  }, [remainingBalance]);

  useEffect(() => {
    recalculateChangeDue(fields.amount.rawValue, remainingBalance);
  }, [fields.amount.rawValue]);

  const recalculateChangeDue = (amountGiven, remaining) => {
    const balance = parseFloat(remaining);
    amountGiven = parseFloat(amountGiven);
    if (amountGiven > balance) {
      setChangeDue((amountGiven - balance).toFixed(2));
    } else {
      setChangeDue((0.0).toFixed(2));
    }
  };

  const handleCashSubmit = util.general.generateClickHandler(
    { fields },
    () => handleErrors(true),
    () =>
      makePayment({
        amount_given: Number(fields.amount.rawValue),
        ...(payerNameRequired && {
          first_name: fields.first_name.rawValue,
          last_name: fields.last_name.rawValue,
        }),
        payment_delivery_type: fields.payment_delivery_type.rawValue,
        payment_tender_type: CASH,
        change_due: changeDue,
        navigate,
        location,
      }),
  );

  return (
    <FormContainer>
      <FormInput
        id="cash-payment-amt"
        type="number"
        labelTextWhenNoError="Payment Amount"
        errorMessages={paymentAmountErrors}
        field={fields.amount}
        errors={fields.errors}
        fieldActions={actions.fields.amount}
        labelTextVariant="p"
        errorTextVariant="p"
      />
      {payerNameRequired && (
        <>
          <FormInput
            id="cash-first-name"
            labelTextWhenNoError="First Name"
            errorMessages={requireErrors('First Name is required')}
            field={fields.first_name}
            showErrors={errors}
            fieldActions={actions.fields.first_name}
            labelTextVariant="p"
            errorTextVariant="p"
          />
          <FormInput
            id="cash-last-name"
            labelTextWhenNoError="Last Name"
            errorMessages={requireErrors('Last Name is required')}
            field={fields.last_name}
            showErrors={errors}
            fieldActions={actions.fields.last_name}
            labelTextVariant="p"
            errorTextVariant="p"
          />
        </>
      )}
      {/*removing this until it can be configured at the client level
        to render conditionally*/}
      {/*<CheckboxList
        onSelect={(_, v) => actions.fields.payment_delivery_type.set(v.name)}
        selectedName={fields.payment_delivery_type.rawValue}
        items={[
          {
            text: 'In person',
            name: 'in_person',
          },
          {
            text: 'Mail in',
            name: 'mail_in',
          },
        ]}
      />*/}
      <Box padding="16px 0 0">
        <Cluster>
          <ButtonWithAction
            text={'Back to Cart'}
            action={() => navigate('/pos/cart')}
            variant="secondary"
            dataQa="view-cart"
            extraStyles="margin-left: 0"
            textExtraStyles="font-size: 1rem;"
          />
          <ButtonWithAction
            id="submit-cash-btn"
            disabled={
              isLoading ||
              fields.amount.rawValue <= 0 ||
              fields.amount.hasErrors
            }
            isLoading={isLoading}
            text={processBtnText}
            action={handleCashSubmit}
            textExtraStyles="font-size: 1rem;"
          />
        </Cluster>
      </Box>
    </FormContainer>
  );
};

CashCheckoutForm.reducer = cashReducer;
CashCheckoutForm.mapStateToProps = cashMapStateToProps;
CashCheckoutForm.mapDispatchToProps = cashMapDispatchToProps;

export default CashCheckoutForm;
